// Copyright (C) 2021 TANNER AG

import gql from "graphql-tag";

export const FullTSTopicsFragment = gql`
    fragment FullTSTopicsFragment on TSTopic {
        id
        title
        slug
        intro
        order
        active
        banner
        thumbnail(locales: [$lang, de]) {
            handle
            fileName
            width
            height
            url
            mimeType
        }
        tsChapters {
            id
            order
            slug
            title
        }
    }
`;

export default gql`
    query TSTopics($lang: Locale!, $stage: Stage!) {
        tSTopics(locales: [$lang], stage: $stage, orderBy: order_ASC) {
            ...FullTSTopicsFragment
        }
    }
    ${FullTSTopicsFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/tSTopics.js